import { AlpineComponent } from 'alpinejs';

import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const SpeakersList = ({ count }: { count: number }): AlpineComponent => ({
  activeIndex: 0,
  init() {
    const swiper = new Swiper(this.$refs.slider, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 2,
      spaceBetween: 12,
      centeredSlides: false,
      autoplay: true,
      pagination: {
        type: 'fraction',
        el: '.swiper-pagination',
        renderFraction: (curr, total) =>
          `<span class="${curr}"></span> | <span class="${total}"></span>`
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      breakpoints: {
        // when window width is >= 320px
        580: {
          slidesPerView: 3,
          spaceBetween: 12,
          centeredSlides: count < 3
        },
        // when window width is >= 640px
        960: {
          slidesPerView: 4,
          spaceBetween: 30,
          centeredSlides: count < 4
        },
        1340: {
          slidesPerView: 5,
          spaceBetween: 30,
          centeredSlides: count < 5
        }
      }
    });

    swiper.on('slideChange', () => {
      this.activeIndex = swiper.realIndex;
    });
  }
});

export default SpeakersList;
